'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _onlinepbxQuestion = require('./onlinepbx-question');

var _onlinepbxQuestion2 = _interopRequireDefault(_onlinepbxQuestion);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckIcon = function () {
  function CheckIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M40 14L18 36 8 26',
        stroke: '#00BB20',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return CheckIcon;
}();

CheckIcon.defaultProps = {
  width: '48',
  height: '48',
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var OnlinepbxCheckbox = function (_React$Component) {
  _inherits(OnlinepbxCheckbox, _React$Component);

  function OnlinepbxCheckbox() {
    _classCallCheck(this, OnlinepbxCheckbox);

    return _possibleConstructorReturn(this, (OnlinepbxCheckbox.__proto__ || Object.getPrototypeOf(OnlinepbxCheckbox)).apply(this, arguments));
  }

  _createClass(OnlinepbxCheckbox, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            label = _props.label,
            checked = _props.checked,
            onClickChecked = _props.onClickChecked,
            questionText = _props.questionText;

        return _react2['default'].createElement(
          'div',
          { className: 'onlinepbx__lib__checkbox' },
          _react2['default'].createElement('input', {
            className: 'onlinepbx__lib__checkbox__input',
            checked: checked,
            readOnly: true,
            type: 'checkbox'
          }),
          _react2['default'].createElement(
            'button',
            {
              onClick: onClickChecked,
              className: (0, _classnames2['default'])('onlinepbx__lib__checkbox__button', {
                'onlinepbx__lib__checkbox__button__active': checked
              }) },
            checked && _react2['default'].createElement(CheckIcon, { className: 'onlinepbx__lib__checkbox__button__icon' })
          ),
          label && _react2['default'].createElement(
            'div',
            {
              onClick: onClickChecked,
              className: (0, _classnames2['default'])('onlinepbx__lib__checkbox__label', {
                'onlinepbx__lib__checkbox__label__active': checked
              }) },
            label
          ),
          questionText && _react2['default'].createElement(_onlinepbxQuestion2['default'], {
            text: questionText
          })
        );
      }

      return render;
    }()
  }]);

  return OnlinepbxCheckbox;
}(_react2['default'].Component);

exports['default'] = OnlinepbxCheckbox;